export const LoaderConstants = {
    /* possible values: */
    // 'circle', 'dual-ring', 'button-loader', 'heart,
    // 'ring', 'roller', 'default', 'ellipsis', 'grid',
    // 'hourglass', 'ripple', 'spinner'
    defaultLoader: 'ripple',
    buttonLoader: 'ellipsis',
};
